import React, { useState } from "react";
import "./AddPhotos.css";
import { Flex, SafeArea } from "../../components/layout";
import { Button, FileInput, Form, Title } from "../../components/ui";
import { db, storage } from "../../components/firebase/firebase";
import { addDoc, collection } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import Notification from "../../components/ui/alert/Notification";
import { optimizeImage } from "../../functions/image";
import { logEvent } from "../../utils/logger";

function AddPhotos() {
  const [images, setImages] = useState([]); // Stocke les images pour l'upload
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);

  // Upload des images vers Firebase Storage après optimisation
  const uploadImageToStorage = async (img) => {
    const optimizedImage = await optimizeImage(img.file);
    const storageRef = ref(storage, `photos/${Date.now()}_${img.file.name}`);
    await uploadBytes(storageRef, optimizedImage);
    const url = await getDownloadURL(storageRef);
    return url;
  };

  const handleChange = (e) => {
    const files = e.target.files;
    const newImages = [];

    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      const preview = URL.createObjectURL(file);
      newImages.push({ preview, file });
    }

    setImages(newImages);
  };

  // Sauvegarde de l’article dans Firestore avec images finales
  const handleSave = async (e) => {
    e.preventDefault();
    setLoading(true);
    if (!images || images.length === 0) {
      setNotification({
        type: "error",
        message: "Veuillez remplir tous les champs.",
      });
      setLoading(false);
      return;
    }

    try {
      const photosCollection = collection(db, "photos"); // Récupérer la collection correctement
      for (const img of images) {
        await addDoc(photosCollection, {
          name: img.file.name,
          img: await uploadImageToStorage(img),
          createdAt: Date.now(),
        });
      }
      setImages([]);
      setNotification({
        type: "success",
        message: "Action réalisée avec succès.",
      });
      logEvent("INFO", "DB", "Photos uploaded", {
        count: images.length,
        fileNames: images.map((img) => img.file?.name),
      });
    } catch (error) {
      logEvent("ERROR", "DB", "Photos upload failed", {
        error: error.message,
        stack: error.stack,
        attemptedCount: images.length,
      });
      console.error("Erreur lors de la sauvegarde :", error);
      setNotification({ type: "error", message: "Échec de la sauvegarde." });
    } finally {
      setLoading(false);
    }
  };

  return (
    <SafeArea className="AddPhotos">
      <Notification
        state={notification}
        message={notification?.message || ""}
        type={notification?.type || "success"}
        onClose={() => setNotification(null)}
      />
      <Flex type="col" gap={50}>
        <Title level="h3">Ajouter des photos</Title>
        <Form>
          <Flex type="col" gap={20}>
            <FileInput
              label="Photos"
              multiple
              onChange={handleChange}
              value={images}
              accept=".jpg,.png,.webp"
            />
            <Flex type="end-center" className="ctn-btn" gap={15}>
              <Button skin="nobg" to="/">
                Annuler
              </Button>
              <Button onClick={handleSave} loading={loading}>
                Publier
              </Button>
            </Flex>
          </Flex>
        </Form>
      </Flex>
    </SafeArea>
  );
}

export default AddPhotos;
